import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RegistrationComponent } from './registration/registration.component';
import { VolunteerRegistrationComponent } from './volunteer-registration/volunteer-registration.component';
import { CoachRegistrationComponent } from './coach-registration/coach-registration.component';
import { CompetitorRegistrationComponent } from './competitor-registration/competitor-registration.component';
import { VIPRegistrationComponent } from './vip-registration/vip-registration.component';
import { RefereeRegistrationComponent } from './referee-registration/referee-registration.component';
import { MasterRegistrationComponent } from './master-registration/master-registration.component';
import { OwnerRegistrationComponent } from './owner-registration/owner-registration.component';
import { SubmitProtestComponent } from './submit-protest/submit-protest.component';
import { DynamicRegistrationFormComponent } from './dynamic-registration-form/dynamic-registration-form.component';

const routes: Routes = [
	{
		path: ':id/registrationsv2/:formId',
		component: DynamicRegistrationFormComponent,
	},
	{
		path: ':id/registrations',
		component: RegistrationComponent,
		children: [
			{ path: 'volunteer', component: VolunteerRegistrationComponent },
			{ path: 'coach', component: CoachRegistrationComponent },
			{ path: 'competitor', component: CompetitorRegistrationComponent },
			{ path: 'vip', component: VIPRegistrationComponent },
			{ path: 'referee', component: RefereeRegistrationComponent },
			{ path: 'master', component: MasterRegistrationComponent },
			{ path: 'owner', component: OwnerRegistrationComponent },
			{ path: 'protest', component: SubmitProtestComponent },
			{ path: '', redirectTo: '/404' },
		],
	},
	{ path: '', redirectTo: '/404' },
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class EventsRoutingModule {}
